// @flow

import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { localize } from "redux-i18n";
import actionCreators from "@modules/service/actionCreator";
import type {
  DynamicQuestionContent,
  QuestionTypeDetails,
} from "@modules/service/reducer/dynamic-questions/types";
import * as serviceSelectors from "@modules/service/selectors";
import { SchemaForm, View } from "@components";
import { split } from "@transformers/schema";
import { questionTypeUiSchema } from "../dynamic-question-add-wizard/ui-schema";
import type { StepProps } from "@components";

type PropsFromState = $Exact<{
  draft: ?DynamicQuestionContent,
  schema: ?Object,
  isValid: boolean,
}>;

type PropsFromDispatch = $Exact<{
  onUpdateDraft: typeof actionCreators.UpdateDynamicQuestionDraft,
}>;

type Props = $Exact<{
  ...StepProps,
  ...PropsFromLocalize,
  ...PropsFromState,
  ...PropsFromDispatch,
}>;

export class Step1QuestionType extends React.Component<Props> {
  questionTypeSchema = split(this.props.schema, [
    "questionType",
    "questionText",
    "isMandatory",
    "isActive",
    "advisorType",
    "startNotification",
    "updateNotification",
    "closeNotification",
  ]);

  componentDidMount() {
    if (this.props.onChange) {
      this.props.onChange(this.props.draft || {}, this.props.isValid);
    }
  }

  handleChanges = (formData: Object) => {
    if (formData) {
      const updatedDraft = { ...this.props.draft, ...formData };
      this.props.onUpdateDraft(updatedDraft);

      if (this.props.onChange) {
        this.props.onChange(updatedDraft, true);
      }
    }
  };

  get data(): QuestionTypeDetails {
    return {
      questionType: (this.props.draft || {}).questionType,
      questionText: (this.props.draft || {}).questionText,
      isMandatory: (this.props.draft || {}).isMandatory,
      isActive: (this.props.draft || {}).isActive,
      advisorType: "ALL",
      startNotification: false,
      updateNotification: (this.props.draft || {}).updateNotification,
      closeNotification: (this.props.draft || {}).closeNotification,
    };
  }

  render() {
    return (
      <View className="gs-container">
        <div className="col-sm-12">
          {this.props.editable && this.data && this.props.schema && (
            <SchemaForm
              className="w-100"
              formData={this.data}
              schema={this.questionTypeSchema || {}}
              uiSchema={questionTypeUiSchema(this.props.t)}
              onChange={this.handleChanges}
              externalSubmit
            />
          )}
        </div>
      </View>
    );
  }
}

const mapStateToProps = (state): PropsFromState => {
  return {
    draft: serviceSelectors.getDynamicQuestionDraft(state),
    schema: serviceSelectors.getDynamicQuestionRevisionSchema(state),
    isValid: serviceSelectors.isDynamicQuestionDraftValid(state),
  };
};

const mapDispatchToProps: PropsFromDispatch = {
  onUpdateDraft: actionCreators.UpdateDynamicQuestionDraft,
};

export default compose(localize(), connect(mapStateToProps, mapDispatchToProps))(Step1QuestionType);
